import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJcbCardLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 24,
	viewBox: "0 0 34 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 4C0 1.79086 1.79086 0 4 0H30C32.2091 0 34 1.79086 34 4V20C34 22.2091 32.2091 24 30 24H4C1.79086 24 0 22.2091 0 20V4Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.9818 11.9542C22.5131 11.9658 23.0473 11.9308 23.5765 11.9724C24.1123 12.0724 24.2415 12.8836 23.7654 13.1493C23.4406 13.3243 23.0547 13.2145 22.7025 13.2454H21.9818V11.9542ZM23.8837 10.4928C24.0017 10.9095 23.6001 11.2835 23.1988 11.2262H21.9818C21.9903 10.8333 21.9651 10.4068 21.9942 10.0346C22.4817 10.0484 22.9737 10.0066 23.4585 10.0564C23.6667 10.1088 23.841 10.28 23.8837 10.4928ZM26.8126 4.31448C26.8352 5.11012 26.8158 5.94781 26.8223 6.75959C26.8208 10.06 26.8255 13.3603 26.8198 16.6609C26.7984 17.8978 25.7022 18.9726 24.4739 18.9972C23.2443 19.0022 22.0146 18.998 20.7849 18.9994V14.0099C22.1247 14.003 23.4652 14.0239 24.8045 13.9994C25.4258 13.9604 26.1063 13.5505 26.1352 12.8668C26.2084 12.1801 25.561 11.7051 24.9463 11.6301C24.7101 11.624 24.717 11.5613 24.9463 11.5339C25.5326 11.4072 25.9929 10.8004 25.8204 10.1928C25.6735 9.55368 24.9671 9.30631 24.3795 9.30754C23.1815 9.2994 21.9832 9.30641 20.7852 9.30404C20.7929 8.37256 20.769 7.44008 20.798 6.50928C20.893 5.2947 22.0167 4.29307 23.2278 4.3148C24.4229 4.31462 25.6178 4.31462 26.8126 4.31457V4.31448Z",
			fill: "url(#paint0_linear_1107_66750)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.24671 6.63518C7.27731 5.40023 8.37818 4.33427 9.60494 4.31622C10.8299 4.31245 12.0551 4.31568 13.2801 4.31459C13.2767 8.44645 13.2867 12.5788 13.275 16.7104C13.2279 17.9303 12.139 18.976 10.9256 18.9976C9.69828 19.002 8.47083 18.9982 7.24348 18.9994V13.8417C8.43565 14.1234 9.68582 14.2432 10.902 14.0564C11.629 13.9395 12.4244 13.5824 12.6706 12.8282C12.8517 12.1831 12.7497 11.5041 12.7767 10.8419V9.30415H10.6719C10.6624 10.3212 10.6913 11.34 10.6567 12.3558C10.5999 12.9802 9.9816 13.3769 9.39272 13.3557C8.66241 13.3635 7.2152 12.8264 7.2152 12.8264C7.21157 10.9209 7.23639 8.53456 7.24671 6.63536V6.63518Z",
			fill: "url(#paint1_linear_1107_66750)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0654 9.92439C13.9546 9.9479 14.0431 9.54701 14.0148 9.39494C14.0223 8.43341 13.999 7.47083 14.0276 6.50998C14.1223 5.29026 15.2547 4.28613 16.4707 4.31468H20.0517C20.0483 8.44654 20.0582 12.5789 20.0466 16.7105C19.9994 17.9304 18.9104 18.976 17.697 18.9977C16.4696 19.0023 15.2422 18.9984 14.0147 18.9996V13.3486C14.853 14.0364 15.9923 14.1435 17.0367 14.1453C17.824 14.145 18.6067 14.0237 19.3713 13.8421V12.8068C18.5097 13.2362 17.4968 13.509 16.5416 13.2623C15.8753 13.0965 15.3916 12.4525 15.4024 11.7649C15.3252 11.0498 15.7444 10.2949 16.4471 10.0823C17.3196 9.80915 18.2704 10.018 19.0883 10.3732C19.2635 10.4649 19.4413 10.5787 19.3713 10.2858V9.47209C18.0035 9.14667 16.5479 9.02692 15.1737 9.38094C14.776 9.49314 14.3885 9.6633 14.0654 9.92449V9.92439Z",
			fill: "url(#paint2_linear_1107_66750)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 1H30V-1H4V1ZM33 4V20H35V4H33ZM30 23H4V25H30V23ZM1 20V4H-1V20H1ZM4 23C2.34315 23 1 21.6569 1 20H-1C-1 22.7614 1.23858 25 4 25V23ZM33 20C33 21.6569 31.6569 23 30 23V25C32.7614 25 35 22.7614 35 20H33ZM30 1C31.6569 1 33 2.34315 33 4H35C35 1.23858 32.7614 -1 30 -1V1ZM4 -1C1.23858 -1 -1 1.23858 -1 4H1C1 2.34315 2.34315 1 4 1V-1Z",
			fill: "#F2F4F7"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_1107_66750",
				x1: 20.7437,
				y1: 11.343,
				x2: 26.7843,
				y2: 11.343,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#58B03A" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#55B330"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_1107_66750",
				x1: 7.11505,
				y1: 11.7976,
				x2: 13.1811,
				y2: 11.7976,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0F6EB6" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#006DBA"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_1107_66750",
				x1: 14.0059,
				y1: 11.4854,
				x2: 20.0505,
				y2: 11.4854,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#DE0D3D" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#E30138"
				})]
			})
		] })
	]
});
export default SvgJcbCardLogo;
